import React from "react";
import react from "../images/skills/react.svg";
import { useI18n } from "../i18n";

export const Footer = () => {
  const { t } = useI18n();
  const year = new Date().getFullYear();

  // jsx
  return (
    <footer id="footer" className="footer">
      <div className="section-center">
        <p className="footer-text-2">
          {t.footer.builtWith}&nbsp;
          <span className="footer-img-block">
            <img
              src={react}
              alt="React"
              className="footer-img"
              width="20"
              height="20"
            />
          </span>
          &nbsp;{t.footer.by}&nbsp;
          <a
            href="https://www.linkedin.com/in/stephane-nkengue-4bb27b242/"
            target="_blank"
            rel="noreferrer"
            title="LinkedIn — Stéphane Nkengue"
          >
            Stéphane Nkengue
          </a>
        </p>
        {/* Rappel du métier et de la zone desservie, en clair dans le footer */}
        <p className="footer-tagline">
          {t.footer.tagline} · © {year}
        </p>
      </div>
    </footer>
  );
};
